import { ListItem, ListItemIcon, ListItemText, styled, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles/createTheme';
import { ReactNode } from 'react';
import { PartnerTimeZoneTooltip } from 'src/components/DateTime';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { useGlobalStore } from 'src/store';
import { formatLastMessageSinceTime } from 'src/utils/date';

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(4),
}));

export type ActivityMessage = {
  id: string;
  icon: string;
  message: ReactNode;
  timestamp: string;
  color: (theme: Theme) => string;
};

export type ActivityMessageProps = {
  item: ActivityMessage;
};

export const ActivityListItem = ({ item }: ActivityMessageProps) => {
  const { icon, message, timestamp, color } = item;
  const theme = useTheme();
  const currentPartnerId = useGlobalStore.use.selectedPartnerId();
  return (
    <ListItem
      disableGutters
      secondaryAction={
        <PartnerTimeZoneTooltip
          date={timestamp}
          partnerId={currentPartnerId}
          tooltipProps={{ placement: 'right-end' }}
        >
          {formatLastMessageSinceTime(timestamp)}
        </PartnerTimeZoneTooltip>
      }
      sx={{
        paddingRight: theme.spacing(10),
      }}
    >
      <StyledListItemIcon>
        <DynamicIcon name={icon} color={color(theme)} />
      </StyledListItemIcon>
      <ListItemText
        primary={message}
        sx={{
          textWrap: 'auto',
        }}
      />
    </ListItem>
  );
};
